import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { OpenZitiConsoleLibModule } from 'ziti-console-lib';
import { LatencyPolicyFormComponent } from './latency-policy-form.component';

/* OpenZitiConsoleLibModule is what `lib-form-header`, `lib-form-field-container` and
 * `lib-loading-indicator` come from — the same three every other create page in this
 * console is drawn with.
 *
 * AutoCompleteModule is the component pickers. PrimeNG rather than a wrapper of our own
 * because the searching itself is what this field needs and `p-autoComplete` is where it
 * already lives: a query hook, a minimum length and a debounce, all of them inputs. Every
 * app that hosts this form already calls `providePrimeNG`, so it arrives themed. */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatTooltipModule,
        AutoCompleteModule,
        OpenZitiConsoleLibModule,
    ],
    declarations: [LatencyPolicyFormComponent],
    exports: [LatencyPolicyFormComponent],
})
export class FeatureFormLatencyPolicyFormModule {}
